import platformServer from "@/services/http/platformServer";
import mainServerClient from "@/services/http/mainServerClient";

interface CommonParams {
    interfaceName: string;
    /** 随机数，可保证唯一性 */
    noncestr: string;
    /** 时间戳秒数 */
    timestamp?: string;
    format: string;
    version: string;

    bizParamsJson: string;
}

interface signInfo {
    appid: string;
    noncestr: string;
    timestamp: string;
    version: string;
    format: string;
    interfaceName: string;
    sign: string;
}

export function calcAiKuCunRequestApiSign(orderShopId: number, ewaybillAccount: any, signParamsList: CommonParams[]) {
    return platformServer.post<{ signInfoList: signInfo[] }>(orderShopId, "/ewaybill/calc_aikucun_request_api_sign", {
        orderShopId,
        ewaybillAccount,
        signParamsList,
    });
}

interface FindAiKuCunCustomTemplateResult {
    customTemplateUrl: string;

    customParams: (
        | "productInfo"
        | "remark"
        | "orderId"
        | "merStyleNo"
        | "data1"
        | "data2"
        | "data3"
        | "data4"
        | "data5"
        | "data6"
        | "customeBarCode"
        | "barcode"
    )[];
}

export function findAiKuCunCustomTemplate(templateId: number) {
    return mainServerClient.post<FindAiKuCunCustomTemplateResult>(
        `/waybillTemplate/${templateId}:findAikucunCustomTemplate`,
    );
}
